import {
  ADD_FORM,
  DELETE_INDEX,
  RESET_APP_FORMS,
  RESET_FACTOR,
  RESET_FORM,
  RESET_FORM_STATE,
  RESET_REMITTANCE,
  RESET_TRANSACTION,
  RESET_TRANSFER,
  RESET_ACCOUNTING,
  UPDATE_ACCOUNTING,
  SET_ACTION,
  SET_DELETE_QUEUE,
  SET_EDIT_ITEM,
  SET_INDEX,
  SET_PAGE,
  UNDO_DELETE_QUEUE,
  UPDATE_FACTOR,
  UPDATE_FORM,
  UPDATE_FORM_STATUS,
  UPDATE_REMITTANCE,
  UPDATE_TRANSACTION,
  UPDATE_TRANSFER,
  RESET_INSTALLMENT,
  UPDATE_INSTALLMENT,
} from "../../constants/formConstants";

export const setAction = (action) => {
  return {
    type: SET_ACTION,
    action,
  };
};

export const setPage = (page) => {
  return {
    type: SET_PAGE,
    page,
  };
};

export const setIndex = (index) => {
  return {
    type: SET_INDEX,
    index,
  };
};

export const deleteIndex = (index) => {
  return {
    type: DELETE_INDEX,
    index,
  };
};

export const setDeleteQueue = (index) => {
  return {
    type: SET_DELETE_QUEUE,
    index,
  };
};

export const undoDeleteQueue = (index) => {
  return {
    type: UNDO_DELETE_QUEUE,
    index,
  };
};

export const resetAppForms = () => {
  return {
    type: RESET_APP_FORMS,
  };
};

export const resetForm = (page) => {
  return {
    type: RESET_FORM,
    page: page,
  };
};

export const setEditItem = (editItem) => {
  return {
    type: SET_EDIT_ITEM,
    editItem: editItem,
  };
};

export const addForm = () => {
  return {
    type: ADD_FORM,
  };
};

export const updateForm = (key, value, primary = false, updateFlag = false) => {
  return {
    type: UPDATE_FORM,
    key,
    value,
    primary: primary,
    updateFlag,
  };
};

export const updateFormStatus = (status, errors = null) => {
  return {
    type: UPDATE_FORM_STATUS,
    status,
    errors,
  };
};

export const resetAccounting = () => {
  return {
    type: RESET_ACCOUNTING,
  };
};

export const updateAccounting = (key, value) => {
  return {
    type: UPDATE_ACCOUNTING,
    key,
    value,
  };
};

export const resetFactor = () => {
  return {
    type: RESET_FACTOR,
  };
};

export const updateFactor = (key, value) => {
  return {
    type: UPDATE_FACTOR,
    key,
    value,
  };
};

export const resetTransaction = () => {
  return {
    type: RESET_TRANSACTION,
  };
};

export const updateTransaction = (key, value) => {
  return {
    type: UPDATE_TRANSACTION,
    key,
    value,
  };
};

export const resetRemittance = () => {
  return {
    type: RESET_REMITTANCE,
  };
};

export const updateRemittance = (key, value) => {
  return {
    type: UPDATE_REMITTANCE,
    key,
    value,
  };
};

export const resetTransfer = () => {
  return {
    type: RESET_TRANSFER,
  };
};

export const updateTransfer = (key, value) => {
  return {
    type: UPDATE_TRANSFER,
    key,
    value,
  };
};

export const resetInstallment = () => {
  return {
    type: RESET_INSTALLMENT,
  };
};

export const updateInstallment = (key, value) => {
  return {
    type: UPDATE_INSTALLMENT,
    key,
    value,
  };
};

export const resetFormState = () => {
  return {
    type: RESET_FORM_STATE,
  };
};
